import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'weightUnit',
})
export class WeightUnitPipe implements PipeTransform {
  transform(weightUnit: string): string {
    return weightUnit?.toLowerCase().replace('gramm', 'g');
  }
}
